import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import { Login, Logout, NotAuthorized, ForgotPassword, ResetPassword } from '@/components/authentication'
import { UsersList, UserEdit, MyProfile } from '@/components/users'
import { StaffList, StaffEdit } from '@/components/staff'
import { ClientsList, ClientEdit } from '@/components/clients'
import { AssignmentsList, AssignmentEdit, PlacementGoals } from '@/components/assignments'
import { ConsultantTimeSheet } from '@/components/consultantTimeSheet'
import { TimeCardReport } from '@/components/timeCardReport'
import { DirectPlacementList, DirectPlacementEdit, DirectPlacementGoals } from '@/components/directPlacements'
import { CommissionReport, CommissionDetailsReport } from '@/components/commissionReports'
import addAuthentication from './addAuthentication'

import { InvoicingReport } from '@/components/invoicingReport'
import { PayrollReport } from '@/components/payrollReport'
import { GPToCostReport } from '@/components/gpToCostReport'
import { AdminDashboard } from '@/components/dashboard'
import { DealsList, DealWizardContainer } from '@/components/deals'
import { TodosList, TodoDashboard, TodoEdit } from '@/components/todos'
import { TeamsList } from '@/components/teams'
import { Settings } from '@/components/settings'
import { RevenueData } from '@/components/revenueData'
import { ClockLogs } from '@/components/clockLogs'
import { ClockLogsReport } from '@/components/clockLogsReport'
import { TimeManagement } from '@/components/timeManagement'

import {
  loginRoute,
  logoutRoute,
  defaultRoute,
  usersRoute,
  userCreateRoute,
  userEditRoute,
  staffRoute,
  staffCreateRoute,
  staffEditRoute,
  clientsRoute,
  clientCreateRoute,
  clientEditRoute,
  notAuthorizedRoute,
  assignmentsRoute,
  assignmentCreateRoute,
  assignmentEditRoute,
  consultantTimeSheetRoute,
  timeCardReportRoute,
  myProfileRoute,
  directPlacementsRoute,
  directPlacementCreateRoute,
  directPlacementEditRoute,
  commissionDetailsReportRoute,
  commissionReportRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  invoiceReportRoute,
  payrollReportRoute,
  gpToCostReportRoute,
  dashboardRoute,
  dealsRoute,
  dealWizardRoute,
  userAdminTodosRoute,
  userAdminTodoEditRoute,
  userTodoEditRoute,
  userTodoDashboardRoute,
  teamsRoute,
  settingsRoute,
  placementGoalsRoute,
  directPlacementGoalsRoute,
  revenueDataRoute,
  clockLogsRoute,
  clockLogsReportRoute,
  timeManagementRoute
} from '@/lib/constants/routes'

Vue.use(Router)

const buildRouteObject = ({ route, component }) => ({
  path: route.path,
  name: route.name,
  component,
  meta: {
    roles: route.roles || null
  }
})

export default addAuthentication(new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    buildRouteObject({ route: forgotPasswordRoute, component: ForgotPassword }),
    buildRouteObject({ route: resetPasswordRoute, component: ResetPassword }),
    buildRouteObject({ route: loginRoute, component: Login }),
    buildRouteObject({ route: logoutRoute, component: Logout }),
    buildRouteObject({ route: notAuthorizedRoute, component: NotAuthorized }),
    buildRouteObject({ route: defaultRoute, component: Home }),
    buildRouteObject({ route: usersRoute, component: UsersList }),
    buildRouteObject({ route: userCreateRoute, component: UserEdit }),
    buildRouteObject({ route: userEditRoute, component: UserEdit }),
    buildRouteObject({ route: staffRoute, component: StaffList }),
    buildRouteObject({ route: staffCreateRoute, component: StaffEdit }),
    buildRouteObject({ route: staffEditRoute, component: StaffEdit }),
    buildRouteObject({ route: clientsRoute, component: ClientsList }),
    buildRouteObject({ route: clientCreateRoute, component: ClientEdit }),
    buildRouteObject({ route: clientEditRoute, component: ClientEdit }),
    buildRouteObject({ route: assignmentsRoute, component: AssignmentsList }),
    buildRouteObject({ route: assignmentCreateRoute, component: AssignmentEdit }),
    buildRouteObject({ route: assignmentEditRoute, component: AssignmentEdit }),
    buildRouteObject({ route: consultantTimeSheetRoute, component: ConsultantTimeSheet }),
    buildRouteObject({ route: timeCardReportRoute, component: TimeCardReport }),
    buildRouteObject({ route: myProfileRoute, component: MyProfile }),
    buildRouteObject({ route: directPlacementsRoute, component: DirectPlacementList }),
    buildRouteObject({ route: directPlacementCreateRoute, component: DirectPlacementEdit }),
    buildRouteObject({ route: directPlacementEditRoute, component: DirectPlacementEdit }),
    buildRouteObject({ route: commissionReportRoute, component: CommissionReport }),
    buildRouteObject({ route: commissionDetailsReportRoute, component: CommissionDetailsReport }),
    buildRouteObject({ route: invoiceReportRoute, component: InvoicingReport }),
    buildRouteObject({ route: payrollReportRoute, component: PayrollReport }),
    buildRouteObject({ route: gpToCostReportRoute, component: GPToCostReport }),
    buildRouteObject({ route: dashboardRoute, component: AdminDashboard }),
    buildRouteObject({ route: dealsRoute, component: DealsList }),
    buildRouteObject({ route: dealWizardRoute, component: DealWizardContainer }),
    buildRouteObject({ route: userAdminTodosRoute, component: TodosList }),
    buildRouteObject({ route: userAdminTodoEditRoute, component: TodoEdit }),
    buildRouteObject({ route: userTodoEditRoute, component: TodoEdit }),
    buildRouteObject({ route: userTodoDashboardRoute, component: TodoDashboard }),
    buildRouteObject({ route: teamsRoute, component: TeamsList }),
    buildRouteObject({ route: settingsRoute, component: Settings }),
    buildRouteObject({ route: placementGoalsRoute, component: PlacementGoals }),
    buildRouteObject({ route: directPlacementGoalsRoute, component: DirectPlacementGoals }),
    buildRouteObject({ route: revenueDataRoute, component: RevenueData }),
    buildRouteObject({ route: clockLogsRoute, component: ClockLogs }),
    buildRouteObject({ route: clockLogsReportRoute, component: ClockLogsReport }),
    buildRouteObject({ route: timeManagementRoute, component: TimeManagement })
  ]
}))
